import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Pages
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import HelpAndSupport from './pages/HelpAndSupport';
import TermsAndPrivacy from './pages/TermsAndPrivacy';
import NetworkAdminDashboard from './pages/NetworkAdminDashboard';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/help" element={<HelpAndSupport />} />
        <Route path="/terms" element={<TermsAndPrivacy />} />
        <Route path="/privacy" element={<TermsAndPrivacy />} />
        <Route path="/reset/password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly={true}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/network-admin-dashboard"
          element={
            <ProtectedRoute>
              <NetworkAdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
